import {Splide} from '@splidejs/splide';
import '@splidejs/splide/css';

document.addEventListener( 'DOMContentLoaded', function() {
	document.querySelectorAll('.wp-block-sole-slider').forEach((slider) => {
		slider.querySelectorAll('.splide__list > *').forEach((slide) => slide.classList.add('splide__slide'));
		new Splide(slider, {rewind: true, pauseOnHover: true}).mount();
	})
} );

